import { FC, useRef } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header/Header";
import { Footer } from "@/components/Footer/Footer";
import { Loader } from "@/components/Loader/Loader";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";
import { useScrollToTop } from "@/hooks/helperHooks/useScrollToTop";

export const GlobalLayout: FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { colors } = useAppColors();

  useScrollToTop(scrollRef);

  return (
    <div
      style={{
        height: "100dvh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header />

      <div
        ref={scrollRef}
        style={{
          backgroundColor: colors.primary,
          flex: 1,
          overflowY: "auto",
          paddingBottom: "8rem",
        }}
      >
        <Loader hasContainer />
        <Outlet />
      </div>

      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          zIndex: 1000,
        }}
      >
        <Footer />
      </div>
    </div>
  );
};
